import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { NavLink, useNavigate } from 'react-router-dom';
import { HardHat, LayoutDashboard, FileText, Building2, Truck, Users, LogOut, Menu, X, Package, Euro, Settings, ShoppingBag, BarChart3, ShoppingCart } from 'lucide-react';

export default function Sidebar({ open, setOpen }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate('/login'); };

  const links = [
    { to: '/', icon: LayoutDashboard, label: 'Painel' },
    { to: '/orcamentos', icon: FileText, label: 'Orcamentos' },
    { to: '/obras', icon: Building2, label: 'Gestao de Obra' },
    { to: '/frota', icon: Truck, label: 'Frota' },
    { to: '/funcionarios', icon: Users, label: 'Funcionarios' },
    { to: '/materiais', icon: Package, label: 'Materiais' },
    { to: '/fornecedores', icon: ShoppingBag, label: 'Fornecedores' },
    { to: '/mapas-comparativos', icon: BarChart3, label: 'Mapa Comparativo' },
    { to: '/compras', icon: ShoppingCart, label: 'Compras' },
    { to: '/financeiro', icon: Euro, label: 'Financeiro' },
    { to: '/configuracoes', icon: Settings, label: 'Configuracoes' },
  ];

  return (
    <>
      <button data-testid="sidebar-toggle-btn" onClick={() => setOpen(!open)}
        className="lg:hidden fixed top-3 left-3 z-50 btn btn-outline p-2" style={{ boxShadow: 'var(--shadow-sm)' }}>
        {open ? <X size={18} /> : <Menu size={18} />}
      </button>
      {open && <div className="lg:hidden fixed inset-0 bg-black/20 z-30" onClick={() => setOpen(false)} />}
      <aside data-testid="main-sidebar"
        className={`fixed lg:sticky top-0 left-0 h-screen z-40 flex flex-col border-r transition-transform duration-200 ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
        style={{ width: '220px', background: '#fff', borderColor: 'var(--border)' }}>
        <div className="p-4 flex items-center gap-2.5" style={{ borderBottom: '1px solid var(--border)' }}>
          <div className="w-8 h-8 rounded-md flex items-center justify-center" style={{ background: '#1E3A5F' }}>
            <HardHat size={18} strokeWidth={2} color="#fff" />
          </div>
          <div>
            <h1 className="text-sm font-bold" style={{ color: '#1E3A5F' }}>PRUMO</h1>
            <p className="text-[9px]" style={{ color: '#8C95A4' }}>Gestao de Obras</p>
          </div>
        </div>
        <nav className="flex-1 py-2 overflow-y-auto scrollbar-thin">
          {links.map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} end={to === '/'}
              data-testid={`nav-${label.toLowerCase().replace(/\s+/g, '-')}`}
              className={({ isActive }) => `sidebar-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setOpen(false)}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3" style={{ borderTop: '1px solid var(--border)' }}>
          <p className="text-xs font-medium truncate mb-2" style={{ color: '#5A6474' }}>{user?.name || user?.email}</p>
          <button data-testid="logout-btn" onClick={handleLogout} className="btn btn-outline w-full text-xs py-1.5">
            <LogOut size={14} /> Sair
          </button>
          <p className="text-[9px] text-center mt-2" style={{ color: '#C8D6E8' }}>Criado por: Rui Guimaraes</p>
        </div>
      </aside>
    </>
  );
}
